/* nxg-v10-collection.js - Main Theme V10 (NOMAD phase 2). Collection pages.
   1. Previous / next controls for the category rail (the rail also scrolls
      natively by touch, trackpad and keyboard).
   2. Filter form: submits on checkbox and sort changes, drops empty price
      fields so URLs stay clean, one filter panel open at a time, Escape and
      outside click close the open panel. Without JavaScript the form still
      submits with its Apply button. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step(rail) {
    var item = rail.firstElementChild;
    if (!item) return 0;
    var gap = parseFloat(getComputedStyle(rail).columnGap) || 20;
    return item.getBoundingClientRect().width + gap;
  }

  function sync(rail) {
    var max = rail.scrollWidth - rail.clientWidth - 2;
    document.querySelectorAll('[data-nc-rail="' + rail.id + '"]').forEach(function (btn) {
      var dir = Number(btn.getAttribute('data-dir'));
      btn.disabled = dir < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max;
    });
  }

  function initRails() {
    var seen = {};
    document.querySelectorAll('[data-nc-rail]').forEach(function (btn) {
      var rail = document.getElementById(btn.getAttribute('data-nc-rail'));
      if (!rail) return;
      btn.addEventListener('click', function () {
        rail.scrollBy({ left: Number(btn.getAttribute('data-dir')) * step(rail), behavior: reduce ? 'auto' : 'smooth' });
      });
      if (!seen[rail.id]) {
        seen[rail.id] = true;
        rail.addEventListener('scroll', function () { sync(rail); }, { passive: true });
        window.addEventListener('resize', function () { sync(rail); });
        sync(rail);
      }
    });
  }

  function clean(form) {
    form.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (input) {
      if (input.value === '') { input.disabled = true; input.setAttribute('data-nc-off', ''); }
    });
    var sort = form.querySelector('select[data-nc-sort]');
    if (sort && sort.value === sort.getAttribute('data-default')) { sort.disabled = true; sort.setAttribute('data-nc-off', ''); }
  }

  /* Sync every filter control to the current URL. After Back/Forward the
     browser can restore a cached page, or re-fill the form from its own form
     state, with the ticks of the page the shopper just left. The URL is the
     truth (the grid is rendered from it), so the form is set from it. */
  function syncToUrl(form) {
    var params = new URLSearchParams(window.location.search);
    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      var want = params.getAll(input.name).indexOf(input.value) !== -1;
      if (input.checked !== want) input.checked = want;
      input.defaultChecked = want;
    });
    form.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (input) {
      var v = params.get(input.name) || '';
      if (input.value !== v) input.value = v;
    });
    var sort = form.querySelector('select[data-nc-sort]');
    if (sort) {
      var s = params.get('sort_by') || sort.getAttribute('data-default') || '';
      if (sort.querySelector('option[value="' + s.replace(/"/g, '') + '"]') && sort.value !== s) sort.value = s;
    }
  }

  /* Back/forward cache: undo what clean() switched off so the form works
     again, then re-sync the controls to the URL. */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-nc-off]').forEach(function (el) { el.disabled = false; el.removeAttribute('data-nc-off'); });
    document.querySelectorAll('form[data-nc-filters]').forEach(function (f) { f.classList.remove('is-loading'); syncToUrl(f); });
  });

  function send(form) {
    clean(form);
    form.classList.add('is-loading');
    form.submit();
  }

  function initFilters() {
    document.querySelectorAll('form[data-nc-filters]').forEach(function (form) {
      var panels = form.querySelectorAll('details[data-nc-filter]');

      form.addEventListener('submit', function () { clean(form); });

      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('input[type="checkbox"]') || t.matches('select[data-nc-sort]')) send(form);
      });

      panels.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          panels.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        panels.forEach(function (d) {
          if (d.open) {
            d.open = false;
            var s = d.querySelector('summary');
            if (s) s.focus();
          }
        });
      });

      document.addEventListener('click', function (e) {
        panels.forEach(function (d) {
          if (d.open && !d.contains(e.target)) d.open = false;
        });
      });
    });
  }

  function init() { initRails(); initFilters(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* rv30 (30 Sep): compact category row. Browsers only scroll a focused link
   into view when it is fully hidden, so a half-visible pill could take focus
   without the strip moving. Bring the focused pill fully into view, inside
   the strip and clear of the consent banner (scroll-margin in the CSS). */
(function () {
  document.addEventListener('focusin', function (e) {
    var a = e.target;
    if (!a || !a.closest || !a.closest('.nc-qcats')) return;
    a.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
})();
